import { Pipe, PipeTransform } from '@angular/core';
import { EntitlementKey } from '../models/entitlement';
import { Entitlement } from '../models/entitlement';

@Pipe({ 
  standalone: false,
  name: 'entitlementClientNameFilter' 
})

export class FilterEntitlementClientNamePipe implements PipeTransform {
  transform(items: Entitlement[] | null, searchText: string): Entitlement[] {
    if (!searchText) return items!;

    return items!.filter((entitlement: Entitlement) =>
      entitlement.clientName.toLowerCase().includes(searchText?.toLowerCase()),
    );
  }
}

@Pipe({ 
  standalone: false,
  name: 'entitlementValueFilter' 
})

export class FilterEntitlementValuePipe implements PipeTransform {
  transform(items: EntitlementKey[], searchText: string): EntitlementKey[] {
    if (!searchText) return items;
    const lowerCasedSearchText = searchText.toLowerCase();
    return items.filter(
      (item) =>
        Object.keys(item.data).some((key) =>
          item.data[key].toLowerCase().includes(lowerCasedSearchText),
        ) ||
        (item.description &&
          Object.keys(item.description).some(
            (key) =>
              item.description &&
              item.description[key] &&
              item.description[key]
                .toLowerCase()
                .includes(lowerCasedSearchText),
          )),
    );
  }
}
